//E8 is userAge

import { FREQUENCY } from "../constants/constants";
// should be singleorNot4
export const singleRetirementDistribution = (E8, E14, E15, newportfolio, portfolio, singleOrNot5, singleOrNo4, distributionAge = 115) => {
    var iteration = distributionAge - E8;
    var contribution;
    var age = Math.min(E8);
    var portfolioValue;
    var Distribute;
    var portfolioValue2;
    let accountValue = 0;
    var accountValues = [];
    var contributionPlusDistribution = [];
    var j = 0;
    var Age = [];
    for (var i = 0; i < iteration; i++) {
        if(age >= 72) {
            j++;
        }
        if (i === 0) {
            contribution = age >= 72 ? 0 : 0;
            portfolioValue = age >= 72 ? 0 : newportfolio;
            Distribute = age >= 72 ? singleOrNot5[j] : 0;
            portfolioValue2 = age >= 72 ? singleOrNo4[j] : 0;
            accountValue = Math.trunc(portfolioValue + portfolioValue2);
            accountValues.push(accountValue);
            contributionPlusDistribution.push(contribution + Distribute);
        } else {
            age += 1;
            contribution = age >= 72 ? 0 : E14 * E15;
            portfolioValue = age >= 72 ? 0 : portfolio[i - 1];
            Distribute = age >= 72 ? singleOrNot5[j] : 0;
            portfolioValue2 = age >= 72 ? singleOrNo4[j] : 0;
            accountValue = Math.trunc(portfolioValue + portfolioValue2);
            accountValues.push(accountValue);
            contributionPlusDistribution.push(contribution - Distribute);
        }
        Age.push(Math.round(age));
    }

    return [Age, accountValues, contributionPlusDistribution];
}

// PV, t, D5, i, D7, A, D9
// singleCompoundGrowth(E9, E10, E11, E12, E13, E14, E15);
// D5 is removed
export const singleCompoundGrowth = (
        totalInvestment, 
        investmentYears, 
        interestRate, 
        compoundFrequency = 1,
        contributions,
        cadence
    ) => {
    const year = 365;
    let pmt = (investmentYears * cadence) + 1;

    let rate;
    if (compoundFrequency === year) {
        rate = interestRate / year;
    } else {
        rate = Math.pow((1 + interestRate / compoundFrequency), (compoundFrequency / cadence)) - 1;
    }

    let G4 = 0;
    let G5 = 0;
    let G6 = 0;
    let G7 = 0;
    let port = 0;
    let portfolio = [];

    for(let j = 0; j < pmt; j++) {
        if (j === 0) {
            G4 = G4 + 0;
            G6 = G6 + 0;
            port = port + totalInvestment;
            portfolio.push(port);
        } else {
            G4 += contributions;
            G6 += port * rate;
            port = contributions + (port * rate) + port;
            portfolio.push(port);
        }
    }
    G5 = G4 + totalInvestment;
    G7 = port;
    return [G4, G5, G6, G7, portfolio];
}

export const singleOrNot = (E7, E6) => {
    let age = 71;
    let factor = [25.6, 24.7, 23.8, 22.9, 22.0, 21.1, 20.3, 19.5, 18.7, 17.9, 17.1, 16.3, 15.5, 14.8, 14.1, 13.4, 12.7, 12.0, 11.4, 10.8, 10.2, 9.6, 9.1, 8.6, 8.1, 7.6, 7.1, 6.7, 6.3, 5.9, 5.5, 5.2, 4.9, 4.5, 4.2, 3.9, 3.7, 3.4, 3.1, 2.9, 2.6, 2.4, 2.1, 1.9];
    let max = 114;
    let yearsleft;
    let B = [];
    let C = [];
    let D = [];
    let E = [];
    let F = [];

    for (let i = 0; i < 44; i++) {
        if (i === 0) {
            yearsleft = max - age;
            age += 1;
            B.push(age);
            C.push(factor[i]);
            D.push(yearsleft);
            E.push(E6);
            F.push(E6 / factor[i]);
        } else {
            yearsleft = max - age;
            age += 1;
            B.push(age);
            C.push(factor[i]);
            D.push(yearsleft);
            let j = i;
            let calc = (E[j - 1] - F[j - 1]) * E7 + (E[j - 1] - F[j - 1])
            E.push(calc);
            F.push(calc / factor[i]);
        }
    }

    return [B, C, D, E, F];
}

export const taxableCompoundGrowth = (portfolioValue, yearsToInvest, internalReturnRate, contribution, contributionFrequency = FREQUENCY.ANNUALLY) => {
  // the formula takes the previous value and adds contributions and growth
  // how do i calculate growth?

  // grwoth uses previous value TIMES contribution rate
  // if its daily compound, then we use 365 as the exponential
  // however 365 is only for next years, the first year should be 365 - current date to see how many days we have left in the year

  // payments decide how many bars there are because each payment represents one contribution
  // there are many payments if we change the contribution frequency
  // but we only want to show how many years
  // so we go every 12 index
  // lets keep to simplist feature first
  // assume contribution frequency is annual
  const payments = yearsToInvest * contributionFrequency;
  const compoundPortfolio = [];
  const contributions = [];
  let currentPortfolioValue = portfolioValue;

  for(let i = 0; i < payments; i++) {
    // future value is currentPortfolioValue + Growth + Contributions
    // growth is currentPortfolioValue * rate OR if its contributionFrequency dependent, then its currentPortfolioValue * ((1 + rate/(contributionFrequency) ^ (contributionFrequency * yearsToInvest)) - 1)
    const growth = currentPortfolioValue * internalReturnRate;
    const futureValue = currentPortfolioValue + growth + contribution;
    compoundPortfolio.push(futureValue);
    contributions.push(contribution);

    currentPortfolioValue = futureValue;
  }

  return { compoundPortfolio, contributions };
}

export const taxableSinker = (initialPortfolioValue, portfolioValue, yearsToDistribute, distributionRate) => {
  if(!portfolioValue) portfolioValue = initialPortfolioValue;
  // factor is the number of years to distribute
  // depletion = currentPortfolioValue / factor
  // portfolio value is (currentPortfolioValue - depletion) * distributionRate+(currentPortfolioValue - depletion)
  const payments = yearsToDistribute;
  const distributionPortfolio = [portfolioValue];
  const distributions = [];
  let currentPortfolioValue = portfolioValue;

  for(let i = 0; i < payments; i++) {
    const factor = payments - i;
    const depletion = currentPortfolioValue / factor;
    const futureValue = ((currentPortfolioValue - depletion) * distributionRate) + (currentPortfolioValue - depletion);

    distributionPortfolio.push(futureValue);
    distributions.push(depletion * -1);

    currentPortfolioValue = futureValue;
  }
  
  distributionPortfolio.pop();

  return { distributionPortfolio, distributions }
}

export const taxableRetirementDistribution = (portfolioValue, compoundPortfolio, contributions, distributionPortfolio, distributions) => {
  // should take in initial account value
  // should take in compound portfolio and contributions
  // should take in distribution portolio and distributions
  const labels = ['-']
  const contributionDistributionPortfolio = [portfolioValue];
  const contributionDistributions = [0];

  const portfolioLength = compoundPortfolio.length + distributionPortfolio.length;
  for(let i = 0; i < portfolioLength; i++) {
    labels.push(i + 1);
  }
  // map creates a shallow copy
  // manually looping can save memory since these can be big charts
  for(let i = 0; i < compoundPortfolio.length; i++) {
    contributionDistributionPortfolio.push(compoundPortfolio[i]);
    contributionDistributions.push(contributions[i]);
  }

  for(let i = 0; i < distributionPortfolio.length; i++) {
    contributionDistributionPortfolio.push(distributionPortfolio[i]);
    contributionDistributions.push(distributions[i]);
  }

  return { labels, contributionDistributionPortfolio, contributionDistributions }
}